/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_H2Inputs */

const es_landing_pricing_h2 = /** @type {(inputs: Landing_Pricing_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obligatorio por ley. Y aun así, lo más barato.`)
};

const gl_landing_pricing_h2 = /** @type {(inputs: Landing_Pricing_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigatorio por lei. E aínda así, o máis barato.`)
};

const en_landing_pricing_h2 = /** @type {(inputs: Landing_Pricing_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required by law. Still the cheapest.`)
};

/**
* | output |
* | --- |
* | "Required by law. Still the cheapest." |
*
* @param {Landing_Pricing_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_h2 = /** @type {((inputs?: Landing_Pricing_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_pricing_h2(inputs)
	if (locale === "en") return en_landing_pricing_h2(inputs)
	return es_landing_pricing_h2(inputs)
});